import utils from '@/mixins/utils.js'

export const dataFieldsDia = {
  Dia: 'nu_dia',
  Emergência: 'emergencia',
  'Muito Urgente': 'muito_urgente',
  Urgente: 'urgente',
  'Não urgente': 'nao_urgente',
  Baixa: 'baixa',
  'Sem classificação': 'sem_classificacao',
  'Total do dia': 'total_do_dia',
}

export const dataFieldsMes = {}

export const dataFieldsEspera = {}

export const dataFieldsClassificacao = {}

export const infoHtml = ``
